module.exports = __webpack_public_path__ + "img/collection-memoireRingsBudgetMedium@2x.8c2488d.jpg";